export class EChartUtils {
  static generateTimeLabels = () => {
    const times: string[] = []
    for (let i = 0; i <= 24 * 60; i += 2) {
      // 每隔2分钟
      const hours = Math.floor(i / 60)
        .toString()
        .padStart(2, '0')
      const minutes = (i % 60).toString().padStart(2, '0')
      times.push(`${hours}:${minutes}`)
    }
    return times
  }
}
